// components/DepartmentManager.js
import React from 'react';
import { Button } from '@dhis2/ui';
import SectionManager from './SectionManager';

const DepartmentManager = ({
  departments,
  onRemoveDepartment,
  onUpdateDepartment
}) => {
  return (
    <div>
      {departments.map(department => (
        <div key={department.id} style={{ marginBottom: '20px', padding: '15px', border: '1px solid #ddd', borderRadius: '4px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '16px' }}>{department.name}</strong>
            <Button small destructive onClick={() => onRemoveDepartment(department.id)}>
              Remove Department
            </Button>
          </div>

          <SectionManager
            department={department}
            onAddSection={() => onUpdateDepartment(department.id, 'addSection')}
            onRemoveSection={(sectionId) => onUpdateDepartment(department.id, 'removeSection', sectionId)}
            onUpdateSectionInput={(value) => onUpdateDepartment(department.id, 'newSection', value)}
            onUpdateSection={(sectionId, action, value) => onUpdateDepartment(department.id, 'updateSection', {
              sectionId,
              action,
              value
            })}
          />
        </div>
      ))}
    </div>
  );
};

export default DepartmentManager;